export default [
  {
    fnKey: "array_length",
    key: "similar_artists",
    score: {
      influencer: 15,
      band: 10,
    },
  },
]
